export const formatDate = (date: Date | string) => new Date(date).toLocaleString().replace(',', '')
